import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './sections/Hero';
import { PainPoints } from './sections/PainPoints';
import { BeforeAfter } from './sections/BeforeAfter';
import { Volumes } from './sections/Volumes';
import { Bonuses } from './sections/Bonuses';
import { System } from './sections/System';
import { Offer } from './sections/Offer';
import { Guarantee } from './sections/Guarantee';
import { Testimonials } from './sections/Testimonials';
import { AboutKarito } from './sections/AboutKarito';
import { Audience } from './sections/Audience';
import { Faq } from './sections/Faq';
import { FinalCta } from './sections/FinalCta';
import { Footer } from './sections/Footer';
export function App() {
  return <div className="w-full bg-white font-sans antialiased" data-id="element-0" data-mp="28s2z1ddy01vz">
      <MetaPixel data-id="element-1" data-mp="23ujha3i1d6za" />
      <Hero data-id="element-2" data-mp="23v2u55stx56g" />
      <main data-id="element-3" data-mp="23ti7e2craqj5">
        <PainPoints data-id="element-4" data-mp="3ijxsv0nzqion" />
        <BeforeAfter data-id="element-5" data-mp="3ikr0s4yore8d" />
        <Volumes data-id="element-6" data-mp="3ij65ue8glt9z" />
        <Bonuses data-id="element-7" data-mp="3ijpe138b53at" />
        <System data-id="element-8" data-mp="3ii4qvyobommz" />
        <Offer data-id="element-9" data-mp="3mlayb9n68jv1" />
        <Guarantee data-id="element-10" data-mp="3mkrefndynled" />
        <Testimonials data-id="element-11" data-mp="3mk85gw6ag7ch" />
        <AboutKarito data-id="element-12" data-mp="3mjg9vlcoy9m7" />
        <Audience data-id="element-13" data-mp="3rc9d24sih9w6" />
        <Faq data-id="element-14" data-mp="3rbrbcsn2y3gv" />
        <FinalCta data-id="element-15" data-mp="3rdaquh0wwahl" />
      </main>
      <Footer data-id="element-16" data-mp="3rd19tixuhdo1" />
      <FloatingCta data-id="element-17" data-mp="3reltgdimfc74" />
      <PurchasePopup data-id="element-18" data-mp="5ott78p769p" />
    </div>;
}